import { createContext } from "react";
import { Theme, teamsLightTheme } from "@fluentui/react-components";
import { TeamsUserCredential } from "@microsoft/teamsfx";
import { ThemeString } from "../utils/useTeamsContext";

export type AppContextType = {
  isTeams: boolean;
  appTheme: ThemeString;
  fluentTheme: Theme;
  teamsUserCredential?: TeamsUserCredential;
};

export const AppContext = createContext<AppContextType>({
  isTeams: false,
  appTheme: "light",
  fluentTheme: teamsLightTheme,
  teamsUserCredential: undefined,
});
